const getSiteUrl = () => {
  if (typeof process !== 'undefined' && process.env && process.env.REACT_APP_SITE_URL) {
    return process.env.REACT_APP_SITE_URL;
  }
  return 'https://tz-creation.tabrezdal.com';
};

// Adding a new project below? Also add its URL (`/ui-ux-project/<key>`)
// to reactSnap.include in package.json, or it won't get prerendered.
const UiUxProjectPageData = {
  uiux01: {
    id: "u01",
    pageName: "Bidroid Old Ui",
    menuName: "Ui/Ux Projects",
    slug: "bidroid-old-ui",
  },
  uiux02: {
    id: "u02",
    pageName: "Bidroid New Ui",
    menuName: "Ui/Ux Projects",
    slug: "bidroid-new-ui",
  },
  uiux03: {
    id: "u03",
    pageName: "CricBuzz App Ui",
    menuName: "Ui/Ux Projects",
    slug: "cricbuzz-app-ui",
  },
  uiux04: {
    id: "u04",
    pageName: "Soy Hill Candle Co.",
    menuName: "Ui/Ux Projects",
    slug: "soy-hill-candle-co-1",
  },
  uiux05: {
    id: "u05",
    pageName: "Soy Hill Candle Co.",
    menuName: "Ui/Ux Projects",
    slug: "soy-hill-candle-co-2",
  },
  uiux06: {
    id: "u06",
    pageName: "Soy Hill Candle Co.",
    menuName: "Ui/Ux Projects",
    slug: "soy-hill-candle-co-3",
  },
  uiux07: {
    id: "u07",
    pageName: "Bidroid App",
    menuName: "Ui/Ux Projects",
    slug: "bidroid-app",
    ProjectLinks: {
      FigmaDesignLink:
        "https://www.figma.com/file/RbLUu3epsp6MNdS3Q97zea/Bidroid-App-by-TZ?type=design&node-id=1%3A14&mode=design&t=qLbKJkQyjwQ4fLV9-1",
      FigmaDesignEmmbedLink:
        "https://www.figma.com/embed?embed_host=share&url=https%3A%2F%2Fwww.figma.com%2Ffile%2FRbLUu3epsp6MNdS3Q97zea%2FBidroid-App-by-TZ%3Ftype%3Ddesign%26node-id%3D1%253A14%26mode%3Ddesign%26t%3DqLbKJkQyjwQ4fLV9-1",
      FigmaPrototypeLink:
        "https://www.figma.com/proto/RbLUu3epsp6MNdS3Q97zea/Bidroid-App-by-TZ?page-id=1%3A14&type=design&node-id=1-87&viewport=-695%2C3614%2C0.12&t=zHeaHRcMbEkrXC8m-1&scaling=scale-down&mode=design",
      FigmaPrototypeEmbbedLink:
        "https://www.figma.com/embed?embed_host=share&url=https%3A%2F%2Fwww.figma.com%2Fproto%2FRbLUu3epsp6MNdS3Q97zea%2FBidroid-App-by-TZ%3Fpage-id%3D1%253A14%26type%3Ddesign%26node-id%3D1-87%26viewport%3D-695%252C3614%252C0.12%26t%3DzHeaHRcMbEkrXC8m-1%26scaling%3Dscale-down%26mode%3Ddesign",
    },
    description: [
      {
        descriptionTitle: "",
        descriptionContent:
          "Bidroid App introduces a fresh perspective to online shopping through its innovative e-commerce auction store. At its core lies a captivating feature that allows users to place bids on their desired products, with a thrilling twist—victory is claimed by the lowest and most unique bid. This project serves as a captivating showcase of this groundbreaking bidding concept, providing a glimpse into the future of online shopping. Stay tuned for the upcoming detailed design phase, where the intricate layers of Bidroid's interface will be unveiled.",
      },
    ],
    buttonsGroup: {
      View: false,
      Download: false,
      Buy: false,
    },
    socialShareUrl: `${getSiteUrl()}/ui-ux-project/uiux07`,
    tags: [
      { tag: "E-commerce" },
      { tag: "Auctions" },
      { tag: "Bidding" },
      { tag: "Online Shopping" },
      { tag: "Concept" },
    ],
  },
  uiux08: {
    id: "u08",
    pageName: "Tabrez Dal - Expert Product Designer",
    menuName: "Ui/Ux Projects",
    slug: "tabrez-dal-expert-product-designer",
    ProjectLinks: {
      FigmaDesignLink:
        "https://www.figma.com/embed?embed_host=share&url=https%3A%2F%2Fwww.figma.com%2Ffile%2FuPwiXFAmUXMHsarV4GNSIc%2FFinverse-Guru-Revamped-by-TZ%3Ftype%3Ddesign%26node-id%3D0%253A1%26mode%3Ddesign%26t%3DYXkPKRHSMCpm8fNJ-1",
      FigmaDesignEmmbedLink:
        "https://www.figma.com/embed?embed_host=share&url=https%3A%2F%2Fwww.figma.com%2Ffile%2F8pCFiznC4Hq0aj7nAjv3aG%2FTabrez-Dal---Expert-Product-Designer%3Ftype%3Ddesign%26node-id%3D0%253A1%26mode%3Ddesign%26t%3Ds52L1aRTqEaRiIM8-1",
      FigmaPrototypeLink:
        "https://www.figma.com/proto/8pCFiznC4Hq0aj7nAjv3aG/Tabrez-Dal---Expert-Product-Designer?page-id=0%3A1&type=design&node-id=1-2&viewport=225%2C250%2C0.17&t=rkyvMPIH8oKxGrgX-1&scaling=scale-down&mode=design",
      FigmaPrototypeEmbbedLink:
        "https://www.figma.com/embed?embed_host=share&url=https%3A%2F%2Fwww.figma.com%2Fproto%2F8pCFiznC4Hq0aj7nAjv3aG%2FTabrez-Dal---Expert-Product-Designer%3Fpage-id%3D0%253A1%26type%3Ddesign%26node-id%3D1-2%26viewport%3D225%252C250%252C0.17%26t%3DrkyvMPIH8oKxGrgX-1%26scaling%3Dscale-down%26mode%3Ddesign",
    },
    description: [
      {
        descriptionTitle:
          "🎨 Hey there, I'm Tabrez Dal – Crafting Experiences, One Pixel at a Time",
        descriptionContent:
          "As someone who's been immersed in the world of design and development for over 4.5 years, I've embarked on an exciting new journey to share my passion with all of you. I'm thrilled to introduce myself as both a Product Designer and Frontend Developer who's all about turning ideas into captivating realities.",
      },
      {
        descriptionTitle: "🌟 Diving into Design Depth:",
        descriptionContent:
          "Design isn't just my job; it's my true calling. I've spent years perfecting the art of crafting UI/UX experiences that don't just look good, but also feel right. With a strong background in both frontend development and design, I'm all about striking that delicate balance between aesthetics and functionality.",
      },
      {
        descriptionTitle: "🚀 The Expertise You Deserve:",
        descriptionContent:
          "Why call myself an 'Expert Product Designer'? Because I pour my heart and soul into every project. From sleek user interfaces to seamless user experiences, I'm dedicated to creating designs that leave a lasting impact. Your users deserve nothing less than an extraordinary journey through your digital space, and that's exactly what I'm here to provide.",
      },
      {
        descriptionTitle: "📣 Stay in the Loop:",
        descriptionContent:
          "The countdown has begun! Be the first in line to experience design in a whole new light. Keep an eye out for updates – trust me, you won't want to miss what's coming next. Join me as I dive into pixels, lines of code, and boundless creativity. Let's shape digital experiences that resonate and inspire.",
      },
    ],
    buttonsGroup: {
      View: false,
      Download: false,
      Buy: false,
    },
    socialShareUrl: `${getSiteUrl()}/ui-ux-project/uiux08`,
    tags: [
      { tag: "Food Delivery" },
      { tag: "Food" },
      { tag: "Figma" },
      { tag: "Mobile App" },
      { tag: "Custom App Design" },
    ],
  },
  uiux09: {
    id: "u09",
    pageName: "LinkedUp",
    menuName: "Ui/Ux Projects",
    slug: "linkedup",
    ProjectLinks: {
      FigmaDesignLink:
        "https://www.figma.com/file/xFiOecWjbnLfa6oNFC29oe/Linkedup-App-Ui-Design-by-Tabrez-Dal?type=design&node-id=0%3A1&mode=design&t=5hZyAb4DBMGjvnc3-1",
      FigmaDesignEmmbedLink:
        "https://www.figma.com/embed?embed_host=share&url=https%3A%2F%2Fwww.figma.com%2Ffile%2FxFiOecWjbnLfa6oNFC29oe%2FLinkedup-App-Ui-Design-by-Tabrez-Dal%3Ftype%3Ddesign%26node-id%3D0%253A1%26mode%3Ddesign%26t%3D5hZyAb4DBMGjvnc3-1",
      FigmaPrototypeLink:
        "https://www.figma.com/proto/xFiOecWjbnLfa6oNFC29oe/Linkedup-App-Ui-Design-by-Tabrez-Dal?page-id=0%3A1&type=design&node-id=1-20021&viewport=570%2C692%2C0.05&t=LA2mL6kMTT4Dc9oF-1&scaling=scale-down&starting-point-node-id=1%3A14491&mode=design",
      FigmaPrototypeEmbbedLink:
        "https://www.figma.com/embed?embed_host=share&url=https%3A%2F%2Fwww.figma.com%2Fproto%2FxFiOecWjbnLfa6oNFC29oe%2FLinkedup-App-Ui-Design-by-Tabrez-Dal%3Fpage-id%3D0%253A1%26type%3Ddesign%26node-id%3D1-20021%26viewport%3D570%252C692%252C0.05%26t%3DLA2mL6kMTT4Dc9oF-1%26scaling%3Dscale-down%26starting-point-node-id%3D1%253A14491%26mode%3Ddesign",
    },
    description: [
      {
        descriptionTitle:
          "🚀 LinkedUp: Elevating Networking with Next-Gen Features",
        descriptionContent:
          "Drawing inspiration from existing platforms, LinkedUp takes a leap into the future, redefining connectivity with a modern UI and a host of innovative features. This enhanced version not only encompasses the familiar prowess of LinkedIn but also introduces groundbreaking functionalities to enrich the user experience.",
      },
      {
        descriptionTitle:
          "🌟 Redefining Profiles: Unveiling Enhanced User Engagement on LinkedUp",
        descriptionContent:
          "Embrace the power of personalized profiles with the introduction of Categories, allowing users to showcase their multifaceted personas. The job landscape evolves with a New Approach for Jobs and Internships, optimizing opportunities for both job seekers and employers. Scores, Awards & Honors, along with the Gratitude Wall, provide a platform for recognition and appreciation, fostering a culture of achievement.",
      },
      {
        descriptionTitle:
          "📚 Empowerment through Learning: Course Modules and Connectivity on LinkedUp",
        descriptionContent:
          "Experience the evolution of user and organizational profiles, with features that deepen engagement and interaction. The addition of a Creator Profile and Tools Module empowers content creators to shine. Delve into knowledge enhancement with a seamless Course Module, integrating learning journeys within the app.",
      },
      {
        descriptionTitle: "",
        descriptionContent:
          "From Auto Layout to comprehensive prototyping, every detail is meticulously designed to ensure a fluid and immersive experience. LinkedUp isn't just a networking platform; it's a glimpse into the future of connectivity.",
      },
    ],
    buttonsGroup: {
      View: false,
      Download: false,
      Buy: false,
    },
    socialShareUrl: `${getSiteUrl()}/ui-ux-project/uiux09`,
    tags: [
      { tag: "Social Networking" },
      { tag: "Innovation" },
      { tag: "Enhanced Features" },
      { tag: "Future Connectivity" },
      { tag: "Custom App Design" },
    ],
  },
  // uiux10: {
  //   id: "u10",
  //   pageName: "Food Delivery App",
  //   menuName: "Ui/Ux Projects",
  //   slug: "food-delivery-app",
  //   ProjectLinks: {
  //     FigmaDesignLink:
  //       "https://www.figma.com/file/mxGgaGNGBk4UYv1foP0O4M/EatExpress-Food-Delivery-Customer-App?type=design&node-id=63%3A8445&mode=design&t=hCy0IwFDR5Im9Nct-1",
  //     FigmaDesignEmmbedLink:
  //       "https://www.figma.com/embed?embed_host=share&url=https%3A%2F%2Fwww.figma.com%2Ffile%2FmxGgaGNGBk4UYv1foP0O4M%2FEatExpress-Food-Delivery-Customer-App%3Ftype%3Ddesign%26node-id%3D63%253A8445%26mode%3Ddesign%26t%3DhCy0IwFDR5Im9Nct-1",
  //     FigmaPrototypeLink:
  //       "https://www.figma.com/proto/mxGgaGNGBk4UYv1foP0O4M/EatExpress-Food-Delivery-Customer-App?page-id=63%3A8445&type=design&node-id=104-11365&viewport=457%2C72%2C0.05&t=HmVvV7Ec3t7HGrvJ-1&scaling=min-zoom&starting-point-node-id=104%3A11365&show-proto-sidebar=1&mode=design",
  //     FigmaPrototypeEmbbedLink:
  //       "https://www.figma.com/embed?embed_host=share&url=https%3A%2F%2Fwww.figma.com%2Fproto%2FmxGgaGNGBk4UYv1foP0O4M%2FEatExpress-Food-Delivery-Customer-App%3Fpage-id%3D63%253A8445%26type%3Ddesign%26node-id%3D104-11365%26viewport%3D457%252C72%252C0.05%26t%3DHmVvV7Ec3t7HGrvJ-1%26scaling%3Dmin-zoom%26starting-point-node-id%3D104%253A11365%26show-proto-sidebar%3D1%26mode%3Ddesign",
  //   },
  //   description: [
  //     {
  //       descriptionTitle:
  //         "🍽️ Food Delivery App: Partnering for Culinary Convenience",
  //       descriptionContent:
  //         "Experience gastronomic delight through the Food Delivery App, meticulously divided into two distinct modules catering to both partners and customers. The first module delves into the intuitive design of the Food Delivery Partner app, offering seamless interactions for those bringing meals to your doorstep. The second module is dedicated to the Food Delivery Customer app, ensuring a delightful experience for those seeking culinary indulgence.",
  //     },
  //     {
  //       descriptionTitle:
  //         "🚀 Food Delivery App: Crafting Seamless Customer Experience",
  //       descriptionContent:
  //         "This design endeavor goes beyond the ordinary, incorporating a host of advanced features to elevate user engagement. With a comprehensive design system at its core, the app boasts auto-layout functionality, effortlessly adapting to various devices. Every aspect of food delivery is covered, ensuring a fluid and immersive experience. The integration of high-quality images and icons adds visual allure, while component variants with specific properties facilitate personalization.",
  //     },
  //     {
  //       descriptionTitle:
  //         "🎨 Food Delivery App: Design Delights and User-Friendly Feasts",
  //       descriptionContent:
  //         "The app doesn't just stand as a design masterpiece; it's a collaborative playground. Easy customization allows swift modifications across the design, making it developer, designer, and user-friendly. With a focus on the best user experience, the app is fully prototyped, offering interactive screens that provide a glimpse into the app's functionality.",
  //     },
  //   ],
  //   buttonsGroup: {
  //     View: false,
  //     Download: false,
  //     Buy: false,
  //   },
  //   socialShareUrl: `${getSiteUrl()}/ui-ux-project/uiux10`,
  //   tags: [
  //     { tag: "Food Delivery" },
  //     { tag: "Food Delivery Ui Kit" },
  //     { tag: "Restaurant Industry" },
  //     { tag: "Prototyping" },
  //     { tag: "Custom App Design" },
  //   ],
  // },
  uiux10: {
    id: "u10",
    pageName: "CasualChic- Casual Wear Store",
    menuName: "Ui/Ux Projects",
    slug: "casual-chic",
    ProjectLinks: {
      FigmaDesignLink:
        "https://www.figma.com/file/kgrvJ33U8tGgQrB7a8zBm5/ultras-casual-wear-ecommerce-figma-template?type=design&node-id=2%3A2&mode=design&t=BOsdJIVKogoeL4R9-1",
      FigmaDesignEmmbedLink:
        "https://www.figma.com/embed?embed_host=share&url=https%3A%2F%2Fwww.figma.com%2Ffile%2FkgrvJ33U8tGgQrB7a8zBm5%2Fultras-casual-wear-ecommerce-figma-template%3Ftype%3Ddesign%26node-id%3D2%253A2%26mode%3Ddesign%26t%3DBOsdJIVKogoeL4R9-1",
      FigmaPrototypeLink:
        "https://www.figma.com/proto/kgrvJ33U8tGgQrB7a8zBm5/ultras-casual-wear-ecommerce-figma-template?page-id=2%3A2&type=design&node-id=2-16&viewport=-74%2C1454%2C0.26&t=GiF8dw9hznw4PGHy-1&scaling=min-zoom&mode=design",
      FigmaPrototypeEmbbedLink:
        "https://www.figma.com/embed?embed_host=share&url=https%3A%2F%2Fwww.figma.com%2Fproto%2FkgrvJ33U8tGgQrB7a8zBm5%2Fultras-casual-wear-ecommerce-figma-template%3Fpage-id%3D2%253A2%26type%3Ddesign%26node-id%3D2-16%26viewport%3D-74%252C1454%252C0.26%26t%3DGiF8dw9hznw4PGHy-1%26scaling%3Dmin-zoom%26mode%3Ddesign",
    },
    description: [
      {
        descriptionTitle:
          "👗 CasualChic - Elevating Casual Wear to New Heights",
        descriptionContent:
          "Step into the world of CasualChic, where fashion meets comfort with a touch of elegance. Our Casual Wear Store is meticulously designed to offer you a curated collection that effortlessly blends relaxed style with a hint of sophistication. Explore a range of clothing and accessories that redefine casual fashion, making every day a fashionable and comfortable affair.",
      },
      {
        descriptionTitle: "🌟 Uncompromising Style and Quality",
        descriptionContent:
          "At CasualChic, we believe that you don't have to sacrifice style for comfort. Our collection features carefully selected pieces that are not only on-trend but also made from high-quality materials. Whether you're dressing for a casual day out or a laid-back evening, you'll find the perfect outfit that allows you to express your style while feeling comfortable.",
      },
      {
        descriptionTitle: "🛍️ Your One-Stop Destination for Effortless Fashion",
        descriptionContent:
          "Browse through our catalog of casual wear essentials, from cozy loungewear to chic everyday outfits. Our user-friendly website ensures a seamless shopping experience, and our commitment to design excellence means you'll enjoy browsing our collections just as much as you'll love wearing our products.",
      },
    ],
    buttonsGroup: {
      View: false,
      Download: false,
      Buy: false,
    },
    socialShareUrl: `${getSiteUrl()}/ui-ux-project/uiux10`,
    tags: [
      { tag: "E Commerce" },
      { tag: "Online Store" },
      { tag: "Garment Store" },
      { tag: "Single Page Design" },
      { tag: "Custom Store Design" },
    ],
  },
  uiux11: {
    id: "u11",
    pageName: "PropertyZone Landing Page",
    menuName: "Ui/Ux Projects",
    slug: "propertyZone-landing-page",
    ProjectLinks: {
      FigmaDesignLink:
        "https://www.figma.com/file/5Qks4oSg8FqMDMMOAUxh8Q/PropertyZone-Landing-Page-by-TZ?type=design&node-id=0%3A1&mode=design&t=2BkZ4AZd7RBhwacI-1",
      FigmaDesignEmmbedLink:
        "https://www.figma.com/embed?embed_host=share&url=https%3A%2F%2Fwww.figma.com%2Ffile%2F5Qks4oSg8FqMDMMOAUxh8Q%2FPropertyZone-Landing-Page-by-TZ%3Ftype%3Ddesign%26node-id%3D0%253A1%26mode%3Ddesign%26t%3D2BkZ4AZd7RBhwacI-1",
      FigmaPrototypeLink:
        "https://www.figma.com/proto/5Qks4oSg8FqMDMMOAUxh8Q/PropertyZone-Landing-Page-by-TZ?page-id=0%3A1&type=design&node-id=2-2&viewport=494%2C190%2C0.08&t=bLp3baauLi1vLuNf-1&scaling=scale-down-width&starting-point-node-id=2%3A2&mode=design",
      FigmaPrototypeEmbbedLink:
        "https://www.figma.com/embed?embed_host=share&url=https%3A%2F%2Fwww.figma.com%2Fproto%2F5Qks4oSg8FqMDMMOAUxh8Q%2FPropertyZone-Landing-Page-by-TZ%3Fpage-id%3D0%253A1%26type%3Ddesign%26node-id%3D2-2%26viewport%3D494%252C190%252C0.08%26t%3DbLp3baauLi1vLuNf-1%26scaling%3Dscale-down-width%26starting-point-node-id%3D2%253A2%26mode%3Ddesign",
    },
    description: [
      {
        descriptionTitle:
          "🏙️ PropertyZone Landing Page: Elegance Redefined for Dubai Real Estate",
        descriptionContent:
          "Welcome to the gateway of elegance in the real estate world - the PropertyZone Landing Page. Crafted for Dubai's renowned Property Zone firm, this landing page is a symphony of sophistication. Built on a component-based foundation, every element is meticulously designed with auto layout, ensuring flawless cohesion. Immerse yourself in a realm of luxury, where the finest properties come to life through high-quality images, elevating the user experience to unparalleled heights.",
      },
      {
        descriptionTitle:
          "🌟 Elevating User Experience: Crafting Luxury on the PropertyZone Landing Page",
        descriptionContent:
          "Step into a fully prototyped environment that not only showcases properties but also showcases excellence in interaction design. From seamless transitions to engaging animations, this landing page sets the bar for the best user interactions. This is more than just a page; it's an experience that encapsulates the essence of luxury living.",
      },
    ],
    buttonsGroup: {
      View: false,
      Download: false,
      Buy: false,
    },
    socialShareUrl: `${getSiteUrl()}/ui-ux-project/uiux11`,
    tags: [
      { tag: "Real Estate" },
      { tag: "Landing Page" },
      { tag: "Prototyping" },
      { tag: "User Experience" },
      { tag: "Luxury" },
    ],
  },
  uiux12: {
    id: "u12",
    pageName: "King Graphics Homepage",
    menuName: "Ui/Ux Projects",
    slug: "king-graphics-homepage",
    ProjectLinks: {
      FigmaDesignLink:
        "https://www.figma.com/file/2MWRQ5KYxaGVXZz5fw5KVz/King-Graphics-Task---4-by-Tabrez-Dal?type=design&node-id=7%3A0&mode=design&t=uTj5I1gM3K9nppEt-1",
      FigmaDesignEmmbedLink:
        "https://www.figma.com/embed?embed_host=share&url=https%3A%2F%2Fwww.figma.com%2Ffile%2F2MWRQ5KYxaGVXZz5fw5KVz%2FKing-Graphics-Task---4-by-Tabrez-Dal%3Ftype%3Ddesign%26node-id%3D7%253A0%26mode%3Ddesign%26t%3DuTj5I1gM3K9nppEt-1",
      FigmaPrototypeLink:
        "https://www.figma.com/proto/2MWRQ5KYxaGVXZz5fw5KVz/King-Graphics-Task---4-by-Tabrez-Dal?page-id=0%3A1&type=design&node-id=7-0&viewport=-107%2C438%2C0.12&t=6m1aYwPGrOzXaDwG-1&scaling=scale-down-width&mode=design",
      FigmaPrototypeEmbbedLink:
        "https://www.figma.com/embed?embed_host=share&url=https%3A%2F%2Fwww.figma.com%2Fproto%2F2MWRQ5KYxaGVXZz5fw5KVz%2FKing-Graphics-Task---4-by-Tabrez-Dal%3Fpage-id%3D0%253A1%26type%3Ddesign%26node-id%3D7-0%26viewport%3D-107%252C438%252C0.12%26t%3D6m1aYwPGrOzXaDwG-1%26scaling%3Dscale-down-width%26mode%3Ddesign",
    },
    description: [
      {
        descriptionTitle:
          "🖥️ King Graphics Homepage: Unveiling Digital Majesty for Dubai's Premier IT Firm",
        descriptionContent:
          "Step into the digital realm of innovation with the King Graphics Homepage—a gateway to Dubai's renowned IT powerhouse. This meticulously designed home page showcases a harmonious blend of aesthetics and technology. Embracing a component-based approach, every element resonates with precision through auto layout, ensuring a seamless and cohesive visual experience. The touch of luxury is evident in every pixel, reflecting the IT firm's reputation for excellence.",
      },
      {
        descriptionTitle:
          "🌐 Royalty in Design: Crafting Luxurious User Experiences on the King Graphics Homepage",
        descriptionContent:
          "Immerse yourself in the epitome of user experience as you navigate through a fully prototyped landscape. High-quality images and thoughtful interactions envelop you in a world where cutting-edge design meets technological prowess. This homepage isn't just a destination—it's a journey of exploration, a testament to the realm where design and IT converge.",
      },
    ],
    buttonsGroup: {
      View: false,
      Download: false,
      Buy: false,
    },
    socialShareUrl: `${getSiteUrl()}/ui-ux-project/uiux12`,
    tags: [
      { tag: "IT Company Website" },
      { tag: "Homepage" },
      { tag: "Prototyping" },
      { tag: "User Experience" },
      { tag: "Luxury" },
    ],
  },
  uiux13: {
    id: "u13",
    pageName: "moneyHop Registration Flow Design",
    menuName: "Ui/Ux Projects",
    slug: "moneyhop-registration-flow-design",
    ProjectLinks: {
      FigmaDesignLink:
        "https://www.figma.com/file/1Y3Qb1E7LnQxkM7LCksV9Z/moneyHop-Registration-Flow-Design-by-Tabrez-Dal?type=design&node-id=1%3A2910&mode=design&t=r9hKa1xHkCMrE759-1",
      FigmaDesignEmmbedLink:
        "https://www.figma.com/embed?embed_host=share&url=https%3A%2F%2Fwww.figma.com%2Ffile%2F1Y3Qb1E7LnQxkM7LCksV9Z%2FmoneyHop-Registration-Flow-Design-by-Tabrez-Dal%3Ftype%3Ddesign%26node-id%3D1%253A2910%26mode%3Ddesign%26t%3Dr9hKa1xHkCMrE759-1",
      FigmaPrototypeLink:
        "https://www.figma.com/proto/1Y3Qb1E7LnQxkM7LCksV9Z/moneyHop-Registration-Flow-Design-by-Tabrez-Dal?page-id=1%3A2910&type=design&node-id=4-316&viewport=-188%2C368%2C0.13&t=kBJgxlbOiavaFd0n-1&scaling=min-zoom&starting-point-node-id=4%3A316&show-proto-sidebar=1&mode=design",
      FigmaPrototypeEmbbedLink:
        "https://www.figma.com/embed?embed_host=share&url=https%3A%2F%2Fwww.figma.com%2Fproto%2F1Y3Qb1E7LnQxkM7LCksV9Z%2FmoneyHop-Registration-Flow-Design-by-Tabrez-Dal%3Fpage-id%3D1%253A2910%26type%3Ddesign%26node-id%3D4-316%26viewport%3D-188%252C368%252C0.13%26t%3DkBJgxlbOiavaFd0n-1%26scaling%3Dmin-zoom%26starting-point-node-id%3D4%253A316%26show-proto-sidebar%3D1%26mode%3Ddesign",
    },
    description: [
      {
        descriptionTitle:
          "📥 Seamlessly Joining: Transforming Onboarding with moneyHop Registration Flow",
        descriptionContent:
          "Witness the transformation of registration with the moneyHop Registration Flow Design—an endeavor to enhance user onboarding for an enriched financial journey. By revamping each screen and refining associated components from mere screenshots provided by the moneyHop team, this project is a testament to design's power.",
      },
      {
        descriptionTitle:
          "🌟 Designing Engagement: Elevating User Experience for moneyHop's Registration",
        descriptionContent:
          "Embrace a new level of user engagement as the registration flow takes on a fresh coat of innovation. With meticulous attention to detail, this redesign breathes life into the user experience. From simplifying steps to enhancing visual aesthetics, the moneyHop Registration Flow Design sets a benchmark for streamlined onboarding.",
      },
    ],
    buttonsGroup: {
      View: false,
      Download: false,
      Buy: false,
    },
    socialShareUrl: `${getSiteUrl()}/ui-ux-project/uiux13`,
    tags: [
      { tag: "Registration Flow" },
      { tag: "User Onboarding" },
      { tag: "Simplified Steps" },
      { tag: "Design Transformation" },
      { tag: "User Experience" },
    ],
  },
  uiux14: {
    id: "u14",
    pageName: "Rush Invoice App",
    menuName: "Ui/Ux Projects",
    slug: "rush-invoice-app",
    ProjectLinks: {
      FigmaDesignLink:
        "https://www.figma.com/file/8tiS3VhfMk0OKuUdtUvBPn/Rush-Invoice-App-by-TZ?type=design&node-id=0%3A1&mode=design&t=br1hdWjR7jn68YSz-1",
      FigmaDesignEmmbedLink:
        "https://www.figma.com/embed?embed_host=share&url=https%3A%2F%2Fwww.figma.com%2Ffile%2F8tiS3VhfMk0OKuUdtUvBPn%2FRush-Invoice-App-by-TZ%3Ftype%3Ddesign%26node-id%3D0%253A1%26mode%3Ddesign%26t%3Dbr1hdWjR7jn68YSz-1",
      FigmaPrototypeLink:
        "https://www.figma.com/proto/8tiS3VhfMk0OKuUdtUvBPn/Rush-Invoice-App-by-TZ?page-id=0%3A1&type=design&node-id=3-131&viewport=192%2C474%2C0.2&t=pE4MhDrzzrTdriOL-1&scaling=scale-down&starting-point-node-id=3%3A131&show-proto-sidebar=1&mode=design",
      FigmaPrototypeEmbbedLink:
        "https://www.figma.com/embed?embed_host=share&url=https%3A%2F%2Fwww.figma.com%2Fproto%2F8tiS3VhfMk0OKuUdtUvBPn%2FRush-Invoice-App-by-TZ%3Fpage-id%3D0%253A1%26type%3Ddesign%26node-id%3D3-131%26viewport%3D192%252C474%252C0.2%26t%3DpE4MhDrzzrTdriOL-1%26scaling%3Dscale-down%26starting-point-node-id%3D3%253A131%26show-proto-sidebar%3D1%26mode%3Ddesign",
    },
    description: [
      {
        descriptionTitle:
          "💰 Rush Invoice App: Accelerating Invoicing and Business Management",
        descriptionContent:
          "Enter the world of seamless financial management with the Rush Invoice App—a dynamic solution born from a client's need for efficient invoicing and holistic business control. This app is a gateway to convenience, enabling end-users to swiftly generate invoices, expedite client communication, process payments, and efficiently manage both invoices and inventory.",
      },
      {
        descriptionTitle:
          "🌐 Seamlessness Redefined: Simplifying Invoices and Inventory with Rush Invoice App",
        descriptionContent:
          "Experience the blend of functionality and user-friendly design as you navigate through a comprehensive suite of tools. This app isn't just about invoices; it's a comprehensive platform that empowers businesses to streamline their financial operations. From creating invoices on the fly to tracking inventory, Rush Invoice App sets a new standard for business management.",
      },
    ],
    buttonsGroup: {
      View: false,
      Download: false,
      Buy: false,
    },
    socialShareUrl: `${getSiteUrl()}/ui-ux-project/uiux14`,
    tags: [
      { tag: "Invoice Management" },
      { tag: "Financial Efficiency" },
      { tag: "Business" },
      { tag: "Finance" },
      { tag: "Inventory Management" },
    ],
  },
  uiux15: {
    id: "u15",
    pageName: "SOS Manager App Single Screen",
    menuName: "Ui/Ux Projects",
    slug: "sos-manager-app-single-screen",
    ProjectLinks: {
      FigmaDesignLink:
        "https://www.figma.com/file/mIF2TzoSD6DjVdhLYhTWg4/SOS-Emergency-App---TZ?type=design&node-id=0%3A1&mode=design&t=IwAt6BJswdJMY9vQ-1",
      FigmaDesignEmmbedLink:
        "https://www.figma.com/embed?embed_host=share&url=https%3A%2F%2Fwww.figma.com%2Ffile%2FmIF2TzoSD6DjVdhLYhTWg4%2FSOS-Emergency-App---TZ%3Ftype%3Ddesign%26node-id%3D0%253A1%26mode%3Ddesign%26t%3DIwAt6BJswdJMY9vQ-1",
      FigmaPrototypeLink:
        "https://www.figma.com/proto/mIF2TzoSD6DjVdhLYhTWg4/SOS-Emergency-App---TZ?page-id=0%3A1&type=design&node-id=2-29&viewport=-1646%2C-198%2C0.25&t=C8YZ0CYJemxPiILV-1&scaling=scale-down&mode=design",
      FigmaPrototypeEmbbedLink:
        "https://www.figma.com/embed?embed_host=share&url=https%3A%2F%2Fwww.figma.com%2Fproto%2FmIF2TzoSD6DjVdhLYhTWg4%2FSOS-Emergency-App---TZ%3Fpage-id%3D0%253A1%26type%3Ddesign%26node-id%3D2-29%26viewport%3D-1646%252C-198%252C0.25%26t%3DC8YZ0CYJemxPiILV-1%26scaling%3Dscale-down%26mode%3Ddesign",
    },
    description: [
      {
        descriptionTitle:
          "🆘 SOS Manager App: Instant Help Through a Single Screen",
        descriptionContent:
          "Introducing the SOS Manager App's Single Screen—a beacon of hope in emergency situations. This user-centric interface empowers individuals with a lifeline to their favorite contacts, ensuring quick access to aid when time is of the essence. Seamlessly sending audio, video, voice recordings, and locations, the app simplifies the process through intuitive gestures, offering a streamlined response.",
      },
      {
        descriptionTitle:
          "🌟 Rapid Response: Unveiling the Power of SOS Manager App's Main Screen",
        descriptionContent:
          "The main screen's design embodies efficiency and urgency, providing a glimpse of the forthcoming comprehensive flow. This app stands as a testament to technology's ability to safeguard lives, epitomizing the power of a simple gesture in times of need.",
      },
    ],
    buttonsGroup: {
      View: false,
      Download: false,
      Buy: false,
    },
    socialShareUrl: `${getSiteUrl()}/ui-ux-project/uiux15`,
    tags: [
      { tag: "Emergency App" },
      { tag: "SOS Manager" },
      { tag: "User Interface" },
      { tag: "Quick Aid" },
      { tag: "Custom App Design" },
    ],
  },
};

export default UiUxProjectPageData;
